'use client';
import style from '@/app/style/servicesetyle.module.css';
import Button from '@/app/btn/page';
import Mydata from '@/app/data/Servies/car_service.json';

function distination({ Mydata }) {
  const data = Mydata[4];
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div>
      <div className="">
        <div id={style.servicectaimage} className={style[data.iamge]}>
          <div className="mx-auto max-w-7xl grid grid-cols-2 flex items-center px-6 lg:pt-10">
            <div id="visionh2">
              <h2 className="text-4xl text-white leading-2   font-normal">
                <span style={{ fontWeight: 'bold', color: '#D5AF34' }}>
                  {data.subtitle}
                </span>{' '}
                <span>{data.title}</span>
              </h2>
              <div className="updatedparapremu display text-white pt-3 mb-3">
                {data.des}
              </div>

              <button
                onClick={scrollTop}
                className="bg-b pr-4 pl-4 mb-7 pt-2 pb-2 rounded-md mt-3"
              >
                BOOK NOW
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default distination;
